/**
 * Dependencies.
 */
import de from './de.translate';
import el from './el.translate';
import en from './en.translate';
import es from './es.translate';
import fi from './fi.translate';
import fr from './fr.translate';
import it from './it.translate';
import pl from './pl.translate';
import pt from './pt.translate';

/**
 * Export.
 */
export default {
  'de-DE': { PARTNERS: de },
  'el-GR': { PARTNERS: el },
  'en-US': { PARTNERS: en },
  'es-ES': { PARTNERS: es },
  'fi-FI': { PARTNERS: fi },
  'fr-FR': { PARTNERS: fr },
  'it-IT': { PARTNERS: it },
  'pl-PL': { PARTNERS: pl },
  'pt-PT': { PARTNERS: pt }
};
